import * as React from 'react';
import { Translate } from '../../shared/LanguageService';
import { Button, ButtonToolbar } from 'react-bootstrap';
import DeleteButton from '../../components/common/DeleteButton';
import { IInvoiceProductTypeListItem } from './Types';
import { getSiteName } from '../../shared/Site';
import * as Site from '../../shared/Site';

interface InvoiceProductTypeListRowProps {
    item: IInvoiceProductTypeListItem;
    edit: (id: number) => void;
    delete: (id: number) => void;
    site: string;
}

const InvoiceProductTypeListRow = (props: InvoiceProductTypeListRowProps) => {
    return (
        <tr className={props.item.site.toLowerCase()}>
            <td>{props.item.name}</td>
            <td>{props.site === getSiteName(Site.Zentuvo) ? 'Zentuvo' : props.item.site}</td>
            <td>{props.item.isSystemDefault ? <i className="material-icons">check</i> : null}</td>
            <td>
                <ButtonToolbar className="btn-group-sm pull-right">
                    <DeleteButton
                        onDelete={() => props.delete(props.item.id)}
                        text={Translate(
                            'invoice-product-types/page/list/row/delete/remove-this-invoice-product-type'
                        )}
                    >
                        <i className="material-icons">delete</i>{' '}
                        {Translate('invoice-product-types/page/list/row/button-label/delete')}
                    </DeleteButton>
                    <Button onClick={() => props.edit(props.item.id)} bsStyle="primary">
                        <i className="material-icons">edit</i>{' '}
                        {Translate('invoice-product-types/page/list/row/button-label/edit')}
                    </Button>
                </ButtonToolbar>
            </td>
        </tr>
    );
};
export default InvoiceProductTypeListRow;
